import { render, staticRenderFns } from "./FormStatic.vue?vue&type=template&id=7f2f98fa&scoped=true"
import script from "./FormStatic.vue?vue&type=script&lang=js"
export * from "./FormStatic.vue?vue&type=script&lang=js"
import style0 from "./FormStatic.vue?vue&type=style&index=0&id=7f2f98fa&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f2f98fa",
  null
  
)

export default component.exports